/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconOscilloscope = StyledIconInline.extend`
  height: ${props => props.height || '21px'};
  width: ${props => props.width || '26px'};
`;

export const IconOscilloscope = (props) => (
    <StyledIconOscilloscope {...props}>
        <svg viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M24.439,19.3731 L1.51,19.3731"/>
                <path d="M6.5107,19.3731 L6.5107,20.3731"/>
                <path d="M2.5103,19.3731 L2.5103,20.3731"/>
                <path d="M10.5107,19.3731 L10.5107,20.3731"/>
                <path d="M14.5112,19.3731 L14.5112,20.3731"/>
                <path d="M18.5112,19.3731 L18.5112,20.3731"/>
                <path d="M22.5117,19.3731 L22.5117,20.3731"/>
                <path d="M1.4927,3.335 C6.3587,3.335 4.8517,15.373 9.4387,15.373 C14.7587,15.373 12.0167,3.335 16.6187,
                3.335 C21.4847,3.335 19.8517,15.373 24.4387,15.373"/>
                <path d="M22.5073,1.5528 C16.6133,3.0168 18.6963,11.3778 12.1403,11.3778 C4.9143,11.3778 8.2803,
                2.3238 2.4653,1.4388" strokeDasharray="0,1.947"/>
            </g>
        </svg>
    </StyledIconOscilloscope>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconOscilloscope/index.js